var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2721 9.27212C13.2721 11.4813 11.4813 13.2721 9.27214 13.2721C7.06301 13.2721 5.27214 11.4813 5.27214 9.27212C5.27214 7.06298 7.06301 5.27212 9.27214 5.27212C11.4813 5.27212 13.2721 7.06298 13.2721 9.27212ZM11.2721 9.27212C11.2721 10.3767 10.3767 11.2721 9.27214 11.2721C8.16758 11.2721 7.27214 10.3767 7.27214 9.27212C7.27214 8.16755 8.16758 7.27212 9.27214 7.27212C10.3767 7.27212 11.2721 8.16755 11.2721 9.27212Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.79417 15.5183C-0.805757 12.0909 -0.945617 6.39409 2.48178 2.79417C5.90918 -0.805757 11.6059 -0.945617 15.2059 2.48178C18.8058 5.90918 18.9457 11.6059 15.5183 15.2059L9.3124 21.7241L2.79417 15.5183ZM14.0698 13.8268L9.24298 18.8965L4.17324 14.0698C1.3733 11.404 1.26452 6.97318 3.93028 4.17324C6.59603 1.3733 11.0268 1.26452 13.8268 3.93028C16.6267 6.59603 16.7355 11.0268 14.0698 13.8268Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeo);
export default __webpack_public_path__ + "static/media/geo.11e4f83c.svg";
export { ForwardRef as ReactComponent };